export const activateOnEnterOrSpace =
  <Args extends unknown[]>(handler: (...args: Args) => unknown, ...args: Args) =>
  (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handler(...args);
    }
  };

export const triggerClickOnEnterOrSpace = (e: KeyboardEvent): void => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    (e.currentTarget as HTMLElement | null)?.click();
  }
};

export const closeOnEscape = (handler: () => unknown) => (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    e.preventDefault();
    handler();
  }
};
